import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { prettyPrintDate } from "@utils/DateUtils";
import Widget from "@components/Widget/Widget";
import { getAviationForecast } from "@features/Weather/services";
import "./AerodromeWarningWidget.scss";
import { useIataContext } from "@contexts/IataContext";
export const AerodromeWarningWidget = () => {
    const { iata } = useIataContext();
    const { t, i18n } = useTranslation();
    const { data: aviationForecast, isLoading: textLoading, error: textError, } = useQuery({
        queryFn: () => getAviationForecast(iata),
        queryKey: ["getAviationForecast"],
    });
    return (_jsx(Widget.Container, { children: _jsx(Widget.Body, { children: _jsx("div", { children: !textLoading && aviationForecast && !textError && (_jsxs(_Fragment, { children: [_jsx("h2", { children: t("weather.widgets.aerodromeWarning.title") }), _jsx("div", { className: "subtitle", children: t("weather.widgets.aerodromeWarning.validFromTo", {
                                from: prettyPrintDate(aviationForecast.from, i18n.language, "d. MMMM") + "Z",
                                to: prettyPrintDate(aviationForecast.to, i18n.language, "d. MMMM") + "Z",
                            }) }), _jsx("div", { className: "parameter-wrapper", children: aviationForecast.parameters.map((param, idx) => (_jsxs("div", { children: [_jsxs("strong", { children: [param.text, ":"] }), _jsx("p", { children: param.in })] }, idx))) })] })) }) }) }));
};
AerodromeWarningWidget.displayName = "AerodromeWarningWidget";
